function notificationsReducer(state, action) {
  let permission = "default";
  if (!("Notification" in window)) {
    console.log("This browser does not support desktop notification");
  } else {
    permission = Notification.permission;
  }
  if (typeof state === "undefined") {
    state = permission; // If state is undefined, initialize it with a default value
  }
  if (action.type === "PERMISION") {
    return action.payload;
  } else {
    return state; // In case an action is passed in we don't understand
  }
}

export default notificationsReducer;
